const COPY_SELECTOR = "[data-copy-text]"
const SHARE_SELECTOR = "[data-share-url]"

async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return true
  }

  const input = document.createElement("textarea")
  input.value = text
  input.setAttribute("readonly", "readonly")
  input.style.position = "absolute"
  input.style.left = "-9999px"
  document.body.appendChild(input)
  input.select()

  try {
    return document.execCommand("copy")
  } finally {
    input.remove()
  }
}

function bumpButtonLabel(button, labelKey) {
  const copiedLabel = button.dataset.copiedLabel || "Copied"
  const originalLabel = button.dataset[labelKey] || button.textContent
  button.textContent = copiedLabel
  window.setTimeout(() => {
    button.textContent = originalLabel
  }, 1200)
}

function bindCopyButtons() {
  if (window.__demoQrCopyBound) return
  window.__demoQrCopyBound = true

  document.addEventListener("click", async (event) => {
    const shareButton = event.target.closest(SHARE_SELECTOR)
    if (shareButton) {
      event.preventDefault()
      const shareUrl = shareButton.dataset.shareUrl
      if (!shareUrl) return

      if (typeof navigator.share === "function") {
        try {
          await navigator.share({
            title: shareButton.dataset.shareTitle || document.title,
            text: shareButton.dataset.shareText || "",
            url: shareUrl
          })
          return
        } catch (error) {
          if (error?.name === "AbortError") return
        }
      }

      try {
        const copied = await copyText(shareUrl)
        if (!copied) return
        bumpButtonLabel(shareButton, "shareLabel")
      } catch (_error) {
        // no-op
      }
      return
    }

    const button = event.target.closest(COPY_SELECTOR)
    if (!button) return

    event.preventDefault()
    const text = button.dataset.copyText
    if (!text) return

    try {
      const copied = await copyText(text)
      if (!copied) return
      bumpButtonLabel(button, "copyLabel")
    } catch (_error) {
      // no-op
    }
  })
}

bindCopyButtons()
